export const LOGO_IMG = "/img/n148kmw9_image.webp";

export const fmtCZK = (n) => (n == null ? "—" : `${Number(n).toLocaleString("cs-CZ")} Kč`);

export const sanitizeName = (s) => (s || "dokument")
  .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
  .replace(/[^\w\-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 60) || "dokument";

export const invoiceStatus = (s) => {
  switch (s) {
    case "paid": return { label: "zaplaceno", cls: "bg-green-500/15 text-green-400" };
    case "overdue": return { label: "po splatnosti", cls: "bg-red-500/15 text-red-400" };
    case "cancelled": return { label: "stornováno", cls: "bg-zinc-500/15 text-zinc-400" };
    default: return { label: "vystaveno", cls: "bg-amber-500/15 text-amber-400" };
  }
};

export const PROTOCOL_CATS = [
  { key: "protocol", label: "Předávací protokol", testid: "protocol" },
  { key: "handover", label: "Foto převzetí", testid: "handover" },
  { key: "return", label: "Foto vrácení", testid: "return" },
];
export const CAT_LABEL = { protocol: "Protokol", handover: "Převzetí", return: "Vrácení" };
